<template>
  <div class="index">
    <p-c-index-page></p-c-index-page>
  </div>
</template>

<script>
  import PCIndexPage from "./PCIndexPage";

  export default {
    name: 'index',
    components: {
      PCIndexPage
    }
  }
</script>

<style scoped>
  .index {
    width: 100%;
    height: 100%;
    background: #fff;
  }
</style>
